export default "__VITE_ASSET__BnBgNdcs__"